export default __webpack_public_path__ + "static/media/zero-touches-production.196d5280.svg";